export function hasOverlap(array1: Array<any>, array2: Array<any>) {
    const set = new Set(array1);
    return array2.some((item) => set.has(item));
}
